import { Swiper, Navigation, Pagination, Scrollbar, Autoplay} from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

export default () => {
    let swiper = new Swiper(".gallery-modal-slider", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    // componente de banner padrão
    let bannerDefault = new Swiper(".banner__default", {
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        watchOverflow: true,
        navigation: {
            nextEl: ".banner-button-next",
            prevEl: ".banner-button-prev",
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    // let swiperMovies = new Swiper(".swiper__movies", {
    //     slidesPerView: 4.3,
    //     spaceBetween: 32,
    //     scrollbar: {
    //         el: ".swiper-scrollbar",
    //         hide: false,
    //     },
    //     breakpoints: {
    //         600: {
    //             slidesPerView: 1.3,
    //             spaceBetween: 32,
    //         },
    //         900: {
    //             slidesPerView: 2.3,
    //             spaceBetween: 32,
    //         },
    //         1200: {
    //             slidesPerView: 4.3,
    //             spaceBetween: 32,
    //         },
    //     },
    // });

    let swiperShop = new Swiper(".swiper__shop", {
        watchOverflow: true,

        navigation: {
            nextEl: ".shop-button-next",
            prevEl: ".shop-button-prev",
        },
        slidesPerView: 6,
        spaceBetween: 32,
        breakpoints: {
            600: {
                slidesPerView: 2,
                spaceBetween: 32,
            },
            900: {
                slidesPerView: 4,
                spaceBetween: 32,
            },
            1200: {
                slidesPerView: 6,
                spaceBetween: 32,
            },
        },
    });

    let swiperGallery = new Swiper(".gallery__slider", {
        navigation: {
            nextEl: ".gallery__next",
            prevEl: ".gallery__prev",
        },
        breakpoints: {
            600: {
                slidesPerView: 1.5,
                spaceBetween: 32,
            },
            900: {
                slidesPerView: 2.5,
                spaceBetween: 32,
            },
            1200: {
                slidesPerView: 1,
            },
        },
    });

    let swiperTab = new Swiper(".swiper__tab", {
        watchOverflow: true,
        slidesPerView: 7,
        breakpoints: {
            600: {
                slidesPerView: 3.3,
            },
            900: {
                slidesPerView: 7,
            },
            1200: {
                slidesPerView: 7,
            },
        },
    });

    let swiperEvent = new Swiper(".swiper__events", {
        watchOverflow: true,
        slidesPerView: 7,
        breakpoints: {
            600: {
                slidesPerView: 3.3,
            },
            900: {
                slidesPerView: 7,
            },
            1200: {
                slidesPerView: 7,
            },
        },
    });
};
